//scrapped from rainbowkit
export function isAndroid() {
    return (typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent));
}
export function isSmallIOS() {
    return (typeof navigator !== 'undefined' && /iPhone|iPod/.test(navigator.userAgent));
}
export function isLargeIOS() {
    return (typeof navigator !== 'undefined' &&
        (/iPad/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)));
}
export function isIOS() {
    return isSmallIOS() || isLargeIOS();
}
export function isMobile() {
    return isAndroid() || isIOS();
}
